import { AgBytesAPI } from "@ai360/core";

/**
 * Shape-adapts `useCropPurposeList()`'s result to the legacy `PicklistAPI.IPicklistValue`-like
 * shape (`{picklistValueGuid, value, id, activeYn}`) a handful of admin CRUD screens'
 * `crop-list.jsx`/`crop-info-list.jsx` nested grids still expect for their Crop Purpose column --
 * those grids are shared with other picklist-backed columns and out of scope to restructure here.
 * Pure data-source swap: `cropPurposes` are unscoped (no `cropGuid`), so `isAgvanceLinked` is
 * always `null` and every row stays selectable, matching today's unrestricted behavior exactly.
 */
export const toLegacyCropPurposePicklistItems = (
    cropPurposes: AgBytesAPI.ICropPurposeSelectionListItem[]
): { picklistValueGuid: string; value: string; id: string; activeYn: boolean }[] =>
    cropPurposes.map((cropPurpose) => ({
        picklistValueGuid: cropPurpose.cropPurposeGuid,
        value: cropPurpose.name,
        id: cropPurpose.cropPurposeId,
        activeYn: cropPurpose.activeYn,
    }));
